import React, { useState } from "react";
import MobileMenu from "./MobileMenu";

const HeaderMobile = ({ menu, storeLink, externalLinks, labels }) => {
	const [isMenuOpen, setIsMenuOpen] = useState(false);

	const handleToggleMenu = () => {
		setIsMenuOpen((x) => !x);
	};
	return (
		<nav className="header--mobile">

			<div className="header__toggle-container">
				<button className={`header__toggle-button ${isMenuOpen ? 'is-open' : ''}`} onClick={handleToggleMenu} aria-label={labels.expandNavigationMenu}></button>
			</div>

			<MobileMenu isOpen={isMenuOpen} menu={menu} storeLink={storeLink} externalLinks={externalLinks} labels={labels} />
		</nav>
	);
};

export default HeaderMobile;
